
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 490 490"}},[_c('path',{attrs:{"d":"M400 0H60c-5.522 0-10 4.477-10 10v470c0 5.523 4.478 10 10 10h340c22.056 0 40-17.944 40-40V40c0-22.056-17.944-40-40-40zM105 470H70V20h35v450zm315-20c0 11.028-8.972 20-20 20H125V20h275c11.028 0 20 8.972 20 20v410z"}}),_c('path',{attrs:{"d":"M385 50H160c-5.523 0-10 4.477-10 10v110c0 5.523 4.477 10 10 10h225c5.522 0 10-4.477 10-10V60c0-5.523-4.478-10-10-10zm-10 110H170V70h205v90zM150 385h60v20h-60zM150 420h80v20h-80z"}})])
      }
    
      }
    